/* agcp.js - "The chair in these photos" card (marker `agcp`), port of the R7
   prototype (pages/chair-in-photos/scripts/agcp-r7.js): an ATTACH row. The
   card has NO add to cart of its own; its check ticks the chair onto the
   page's own ADD TO CART.

   2026-10-07 (plan set-attach v1.2 C3, ruling R3, Datch 2026-09-30): THE ADD
   and THE PRICE moved out of this file into assets/ag-attach.js, the attach
   coordinator shared with the set card (snippets/set-attach-card.liquid).
   This file registers the chair as a card { id, on, items, total, titles,
   refused }; the coordinator extends the theme's own /cart/add.js items array
   with every ticked card's items in ONE request and is the one writer of the
   main button's `.agcf-atc-sub` (the theme's text + every ticked card's
   total). Two cards each wrapping fetch and each re-applying its own text to
   that span would read the other's write as the theme's and sum twice or
   loop; one coordinator cannot. What a client sees and gets is R7's
   behaviour exactly: the chair rides in the theme's own request, the button
   reads desk + chair x quantity while ticked, a 422 on the chair turns the
   card to its sold-out state after the desk was added alone.
   (Before 2026-10-07 this file wrapped window.fetch itself, the precedent
   being agcf.js a8CartShim, and observed the span with a MutationObserver;
   the coordinator carries both mechanics unchanged.)

   THE CARD: its minus/plus (data-agcp-qty-step) are handled here on window
   in the capture phase and stopped, so no theme quantity handler sees
   them and the main #quantity never moves; min 1, max the input's (99).
   The card's price = unit (data-agcp-unit, cents) x quantity, written the
   way money_without_trailing_zeros writes it. A quantity press while
   unchecked checks the box (R6).
   No navigation, no reload; the coordinator is loaded by the snippet right
   before this file (a card that runs first queues on window.AGAttachQ). */
(function () {
  "use strict";
  if (window.AGCP_BOUND) return;
  window.AGCP_BOUND = true;

  var QTY_MAX = 99;

  function card() { return document.querySelector("[data-agcp-card]"); }
  function checkInput(c) { return c ? c.querySelector("[data-agcp-check]") : null; }
  function isOn(c) { var i = checkInput(c); return !!(i && i.checked && !i.disabled); }
  function qtyInput(c) { return c ? c.querySelector("[data-agcp-qty]") : null; }

  function bounds(input) {
    var lo = parseInt(input.getAttribute("min"), 10);
    var hi = parseInt(input.getAttribute("max"), 10);
    lo = lo > 0 ? lo : 1;
    hi = hi >= lo ? hi : QTY_MAX;
    return [lo, hi];
  }
  function clamp(input, v) { var b = bounds(input); return Math.min(b[1], Math.max(b[0], v)); }
  function qtyOf(c) {
    var input = qtyInput(c);
    if (!input) return 1;
    var v = parseInt(input.value, 10);
    return isNaN(v) ? bounds(input)[0] : clamp(input, v);
  }
  function unitOf(c) {
    var u = c ? parseInt(c.getAttribute("data-agcp-unit"), 10) : NaN;
    return isNaN(u) ? 0 : u;
  }

  function mainBtn() { return document.getElementById("add-to-cart-btn"); }
  function mainForm() { var b = mainBtn(); return b && b.closest ? b.closest("form") : null; }
  function mainSub() { var b = mainBtn(); return b ? b.querySelector(".agcf-atc-sub") : null; }
  function mainQtyInput() {
    var f = mainForm();
    return (f && f.querySelector("#quantity")) || document.getElementById("quantity");
  }
  function mainQty() {
    var q = mainQtyInput();
    var v = q ? parseInt(q.value, 10) : 1;
    return v > 0 ? v : 1;
  }

  /* "$3,450" / "$1,351.50" <-> cents, the currency prefix/suffix kept */
  function parse(txt) {
    var m = /^(\D*?)(\d[\d,]*)(?:\.(\d{1,2}))?(\D*)$/.exec((txt || "").trim());
    if (!m) return null;
    var c = parseInt(m[2].replace(/,/g, ""), 10) * 100 + (m[3] ? parseInt((m[3] + "0").slice(0, 2), 10) : 0);
    return isNaN(c) ? null : { cents: c, tpl: [m[1], m[4]] };
  }
  function money(cents, tpl) {
    var whole = Math.floor(cents / 100);
    var rest = cents % 100;
    var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (rest) s += "." + (rest < 10 ? "0" : "") + rest;
    return tpl[0] + s + tpl[1];
  }

  /* the page's own ADD TO CART price is the coordinator's to write */
  function refresh() { if (window.AGAttach) window.AGAttach.refresh(); }

  function paintCard(c) {
    if (!c) return;
    c.classList.toggle("is-on", isOn(c));
    var price = c.querySelector("[data-agcp-price]");
    var unit = parseInt(c.getAttribute("data-agcp-unit"), 10);
    if (!price || isNaN(unit)) return;
    if (!price._agcpTpl) {
      var p = parse(price.textContent);
      price._agcpTpl = p ? p.tpl : ["$", ""];
    }
    var txt = money(unit * qtyOf(c), price._agcpTpl);
    if (price.textContent !== txt) price.textContent = txt;
  }

  function changed(c, fromQty) {
    var chk = checkInput(c);
    if (fromQty && chk && !chk.checked && !chk.disabled) chk.checked = true;
    paintCard(c);
    refresh();
  }

  function step(btn) {
    var c = btn.closest("[data-agcp-card]");
    var input = qtyInput(c);
    if (!input || input.disabled) return;
    var d = parseInt(btn.getAttribute("data-agcp-qty-step"), 10) || 0;
    input.value = clamp(input, qtyOf(c) + d);
    changed(c, true);
  }

  /* typing: clamp what is out of range at once; an empty field is left for
     the next keystroke (the price reads the minimum) and filled on change */
  function typed(input, done) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) {
      if (done) input.value = bounds(input)[0];
    } else {
      var n = clamp(input, v);
      if (done ? String(n) !== input.value : n !== v) input.value = n;
    }
    changed(input.closest("[data-agcp-card]"), !isNaN(v));
  }

  /* the chair became unavailable after the page rendered */
  function soldOut(c) {
    if (!c) return;
    var chk = checkInput(c);
    if (chk) { chk.checked = false; chk.disabled = true; }
    c.setAttribute("data-agcp-off", "");
    var g = c.querySelector("[data-agcp-qty-group]");
    if (g && g.parentNode) g.parentNode.removeChild(g);
    var label = c.querySelector(".agcp-at-label");
    if (label && !label.querySelector(".agcp-at-oos")) {
      var s = document.createElement("span");
      s.className = "agcp-at-oos";
      s.textContent = "Not in Stock";
      label.appendChild(document.createTextNode(" "));
      label.appendChild(s);
    }
    paintCard(c);
    refresh();
  }

  /* ---------- the card as the coordinator sees it ---------- */
  var api = {
    id: "agcp",
    carry: false,
    on: function () { return isOn(card()); },
    items: function () {
      var c = card();
      var id = c ? parseInt(c.getAttribute("data-variant-id"), 10) : NaN;
      return isNaN(id) ? [] : [{ id: id, quantity: qtyOf(c) }];
    },
    total: function () { var c = card(); return isOn(c) ? unitOf(c) * qtyOf(c) : 0; },
    titles: function () {
      /* the full product title (Shopify names it in a 422 description); the label shows the short title */
      var c = card();
      var full = c ? c.getAttribute("data-agcp-title") : null;
      var n = c ? c.querySelector(".agcp-at-name") : null;
      var out = [];
      if (full) out.push(full);
      if (n) out.push(n.textContent.replace(/\s+/g, " ").trim());
      return out;
    },
    refused: function () { soldOut(card()); }
  };
  (window.AGAttachQ = window.AGAttachQ || []).push(api);

  /* ---------- events, all on window in the capture phase ---------- */
  window.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest("[data-agcp-qty-step]");
    if (btn && btn.closest("[data-agcp-card]")) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      step(btn);
    }
  }, true);

  function onType(done) {
    return function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches("[data-agcp-card] [data-agcp-qty]")) { typed(t, done); return; }
      if (t.matches("[data-agcp-card] [data-agcp-check]")) { changed(t.closest("[data-agcp-card]"), false); }
    };
  }
  window.addEventListener("input", onType(false), true);
  window.addEventListener("change", onType(true), true);
  window.addEventListener("pageshow", function () { paintCard(card()); refresh(); });

  window.AGCP_STATE = function () {
    var c = card(), sub = mainSub(), price = c ? c.querySelector("[data-agcp-price]") : null;
    var co = window.AGAttach ? window.AGAttach.state() : null;
    return { checked: isOn(c), qty: qtyOf(c), mainQty: mainQty(), card: price ? price.textContent : null,
             main: sub ? sub.textContent : null, theme: co ? co.theme : null, armed: co ? co.armed : false };
  };

  paintCard(card());
  refresh();
})();
